module.exports = "/images/bio.svg?c1baeb9b4ab817c4e2a381bfc88b4836";